import { applyScreenReader } from "@microsoft/fast-jss-utilities";
import { neutralForegroundRest } from "../utilities/color";
import { applyScaledTypeRamp } from "../utilities/typography";
const styles = {
    label: Object.assign(Object.assign({}, applyScaledTypeRamp("t7")), { display: "inline-block", color: neutralForegroundRest, padding: "0" }),
    label__hidden: Object.assign({}, applyScreenReader()),
};
export default styles;
